// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"VideoPlayer_closeButton___qeQA","fullscreen":"VideoPlayer_fullscreen__G5L_X"};